module.exports = __webpack_public_path__ + "img/piccMidHospi.3f12fa4a.jpg";